import { createListCollection, Portal, Select } from '@chakra-ui/react'
import { useAtom } from 'jotai/react'
import { useEffect, useState } from 'react'

import { Flex } from '@/components/ui/flex'
import { grpCategoryAtom } from '@/store/tasksApprovals/detailsDrawer'
import { IDropdownInfo } from '@/types/tasksApprovals'

const DrowpDown = ({ options, onChange }: { options: IDropdownInfo; onChange: (value: string) => void }) => {
    const [gprCategory] = useAtom(grpCategoryAtom)
    const [value, setValue] = useState<string[]>([])

    useEffect(() => {
        setValue([gprCategory])
    }, [gprCategory])

    const handleChange = (value: string[]) => {
        setValue(value)
        const newValue = value.length ? value[0] : ''
        onChange?.(newValue)
    }

    const generateOptions = () => {
        return Object.keys(options).map((option) => {
            return {
                value: option,
                label: `${options[+option].name} ${options[+option].min} - ${options[+option].max}`,
            }
        })
    }
    const collection = createListCollection({ items: generateOptions() })

    return (
        <Flex alignItems="center" position="relative">
            <Select.Root
                multiple={false}
                value={value}
                collection={collection}
                onValueChange={(e) => handleChange(e.value)}
                fontSize="14px"
                width="100%"
                maxWidth="400px"
            >
                <Select.HiddenSelect />
                <Select.Control>
                    <Select.Trigger>
                        <Select.ValueText />
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                        <Select.Indicator />
                    </Select.IndicatorGroup>
                </Select.Control>
                <Portal>
                    {/* !TODO: find a way to replace `--z-index: 2000!important` with something that not involves !important */}
                    <Select.Positioner css={{ '--z-index': '2000!important', width: 'var(--reference-width)' }}>
                        <Select.Content>
                            {collection.items.map((item) => {
                                return (
                                    <Select.Item item={item} key={item.value}>
                                        {item.label}
                                        <Select.ItemIndicator />
                                    </Select.Item>
                                )
                            })}
                        </Select.Content>
                    </Select.Positioner>
                </Portal>
            </Select.Root>
        </Flex>
    )
}

export default DrowpDown
